import { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import DashboardLayout from "../../controls/DashboardLayout";
import DashboardNavbar from "../../controls/DashboardNavbar";
import MDBox from "../../controls/MDBox";
import { Grid } from "@mui/material";
import { Card } from "react-bootstrap";
import MDTypography from "../../controls/MDTypography";
import ManualAyuda from "../../controls/ManualAyuda";
import MDButton from "../../controls/MDButton";
import DataTable from "../../controls/Tables/DataTable";
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';
import { postData, pathData, deleteData } from "../../Utils/Http/api";
import CircularProgress from '@mui/material/CircularProgress';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

function CasoEstadoListar() {
    const [columns, setColumns] = useState([]);
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);
    const [openDialog, setOpenDialog] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [currentItem, setCurrentItem] = useState(null);
    const [descripcion, setDescripcion] = useState("");
    const [etapas, setEtapas] = useState([]);
    const [selectedEtapa, setSelectedEtapa] = useState(null);
    const [snackbar, setSnackbar] = useState({ open: false, msg: '', severity: 'success' });
    const [openDelete, setOpenDelete] = useState(false);
    const [deleteId, setDeleteId] = useState(null);

    const fetchEtapas = async () => {
        try {
            const res = await postData('/CasoEtapaListar', {});
            const list = res?.value || [];
            setEtapas(list.map(e => ({ id: e.idCasoEtapa, label: e.descripcion })));
        } catch (ex) {
            console.error('Error cargando etapas', ex);
        }
    };

    const fetchData = async () => {
        setLoading(true);
        try {
            const res = await postData('/CasoEstadoListar', {});
            const list = res?.value || [];
            const data = list.map(item => {
                const etapa = etapas.find(e => e.id === item.idCasoEtapa);
                const canModify = item.sistema !== 1;

                const detalle = (
                    <MDBox>
                        <MDTypography variant="h6" color="text" fontWeight="medium">
                            {item.descripcion}
                        </MDTypography>
                        <MDTypography variant="caption" color="info" fontWeight="medium">
                            Etapa: {etapa?.label || 'N/A'}
                        </MDTypography>
                    </MDBox>
                );
                const action = (
                    <MDBox display="flex" gap={1} alignItems="center" justifyContent="center">
                        {canModify && (
                            <>
                                <IconButton
                                    size="small"
                                    onClick={() => handleOpenEdit(item)}
                                    aria-label="editar"
                                >
                                    <EditIcon color="info" />
                                </IconButton>
                                <IconButton
                                    size="small"
                                    onClick={() => { setDeleteId(item.idCasoEstado); setOpenDelete(true); }}
                                    aria-label="eliminar"
                                >
                                    <DeleteIcon color="error" />
                                </IconButton>
                            </>
                        )}
                    </MDBox>
                );
                return {
                    id: item.idCasoEstado,
                    detalle,
                    action
                };
            });

            setRows(data);
            setColumns([
                { Header: 'Estado y Etapa', accessor: 'detalle', align: 'left', width: '80%' },
                { Header: 'Acciones', accessor: 'action', align: 'center', width: '20%' }
            ]);
        } catch (ex) {
            console.error('Error cargando estados', ex);
            setSnackbar({ open: true, msg: 'Error al cargar los estados', severity: 'error' });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchEtapas();
    }, [refreshKey]);

    useEffect(() => {
        if (etapas.length > 0) {
            fetchData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [etapas, refreshKey]);

    const handleOpenAdd = () => {
        setEditMode(false);
        setCurrentItem(null);
        setDescripcion("");
        setSelectedEtapa(null);
        setOpenDialog(true);
    };

    const handleOpenEdit = (item) => {
        setEditMode(true);
        setCurrentItem(item);
        setDescripcion(item.descripcion || "");
        const etapa = etapas.find(e => e.id === item.idCasoEtapa);
        setSelectedEtapa(etapa || null);
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setCurrentItem(null);
        setDescripcion("");
        setSelectedEtapa(null);
    };

    const handleSave = async () => {
        if (!descripcion.trim()) {
            setSnackbar({ open: true, msg: 'La descripción es requerida', severity: 'warning' });
            return;
        }
        if (!selectedEtapa) {
            setSnackbar({ open: true, msg: 'Debe seleccionar una etapa', severity: 'warning' });
            return;
        }

        try {
            if (editMode) {
                const payload = {
                    idCasoEstado: currentItem.idCasoEstado,
                    idCasoEtapa: selectedEtapa.id,
                    descripcion: descripcion
                };
                const res = await pathData(`/CasoEstadoUpdate/${currentItem.idCasoEstado}`, payload);
                if (res?.isSuccess) {
                    setSnackbar({ open: true, msg: 'Estado actualizado correctamente', severity: 'success' });
                    handleCloseDialog();
                    setRefreshKey(prev => prev + 1);
                } else {
                    setSnackbar({ open: true, msg: res?.error || 'Error actualizando estado', severity: 'error' });
                }
            } else {
                const payload = {
                    idCasoEtapa: selectedEtapa.id,
                    descripcion: descripcion
                };
                const res = await postData('/CasoEstadoRegistrar', payload);
                if (res?.isSuccess) {
                    setSnackbar({ open: true, msg: 'Estado creado correctamente', severity: 'success' });
                    handleCloseDialog();
                    setRefreshKey(prev => prev + 1);
                } else {
                    setSnackbar({ open: true, msg: res?.error || 'Error creando estado', severity: 'error' });
                }
            }
        } catch (ex) {
            console.error('Error guardando estado', ex);
            setSnackbar({ open: true, msg: 'Error guardando estado', severity: 'error' });
        }
    };

    const handleCloseSnackbar = () => setSnackbar({ ...snackbar, open: false });

    const handleCancelDelete = () => {
        setDeleteId(null);
        setOpenDelete(false);
    };

    const handleConfirmDelete = async () => {
        if (!deleteId) return;
        try {
            const res = await deleteData(`/CasoEstadoDelete/${deleteId}`);
            if (res?.isSuccess) {
                setSnackbar({ open: true, msg: 'Estado eliminado correctamente', severity: 'success' });
                setOpenDelete(false);
                setDeleteId(null);
                setRefreshKey(prev => prev + 1);
            } else {
                setSnackbar({ open: true, msg: res?.error || 'Error eliminando estado', severity: 'error' });
            }
        } catch (ex) {
            console.error('Error eliminando estado', ex);
            const msg = ex?.message || ex?.response?.data?.detail || 'Error eliminando estado';
            setSnackbar({ open: true, msg, severity: 'error' });
        }
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="secondary"
                                borderRadius="lg"
                                coloredShadow="secondary"
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                            >
                                <MDTypography variant="h6" color="white">
                                    Estados de Caso
                                </MDTypography>
                                <ManualAyuda seccion="Estados de la Gestión" />
                            </MDBox>

                            <MDBox pt={3} py={3} px={2}>
                                <MDBox mb={2} display="flex" gap={1}>
                                    <MDButton
                                        onClick={handleOpenAdd}
                                        variant="gradient"
                                        color="success"
                                        startIcon={<AddIcon />}
                                    >
                                        Agregar Estado
                                    </MDButton>
                                    <MDButton
                                        onClick={() => setRefreshKey(prev => prev + 1)}
                                        variant="outlined"
                                        color="info"
                                        startIcon={<SearchIcon />}
                                    >
                                        Buscar
                                    </MDButton>
                                </MDBox>

                                {loading ? (
                                    <MDBox display="flex" justifyContent="center" alignItems="center" py={6}>
                                        <CircularProgress />
                                    </MDBox>
                                ) : (
                                    <DataTable
                                        key={refreshKey}
                                        table={{ columns, rows }}
                                        isSorted={false}
                                        showTotalEntries
                                        canSearch={false}
                                        noEndBorder
                                        pagination={{ color: 'warning', variant: 'gradient' }}
                                    />
                                )}

                                {/* Dialog Add/Edit */}
                                <Dialog open={openDialog} onClose={handleCloseDialog} fullWidth maxWidth="sm">
                                    <DialogTitle>
                                        {editMode ? 'Editar Estado' : 'Agregar Estado'}
                                    </DialogTitle>
                                    <DialogContent>
                                        <MDBox display="flex" flexDirection="column" gap={2} mt={1}>
                                            <Autocomplete
                                                options={etapas}
                                                getOptionLabel={(option) => option.label || ""}
                                                value={selectedEtapa}
                                                onChange={(e, newValue) => setSelectedEtapa(newValue)}
                                                renderInput={(params) => <TextField {...params} label="Etapa *" />}
                                            />
                                            <TextField
                                                label="Descripción *"
                                                value={descripcion}
                                                onChange={(e) => setDescripcion(e.target.value)}
                                                fullWidth
                                                required
                                            />
                                        </MDBox>
                                    </DialogContent>
                                    <DialogActions>
                                        <MDButton variant="gradient" color="error" onClick={handleCloseDialog}>
                                            Cancelar
                                        </MDButton>
                                        <MDButton variant="gradient" color="info" onClick={handleSave}>
                                            Guardar
                                        </MDButton>
                                    </DialogActions>
                                </Dialog>

                                {/* Dialog Confirm Delete */}
                                <Dialog open={openDelete} onClose={handleCancelDelete} fullWidth maxWidth="xs">
                                    <DialogTitle>Eliminar Estado</DialogTitle>
                                    <DialogContent>
                                        <MDBox>
                                            <MDTypography>¿Confirma que desea eliminar este estado?</MDTypography>
                                        </MDBox>
                                    </DialogContent>
                                    <DialogActions>
                                        <MDButton variant="gradient" color="error" onClick={handleCancelDelete}>
                                            Cancelar
                                        </MDButton>
                                        <MDButton variant="gradient" color="info" onClick={handleConfirmDelete}>
                                            Eliminar
                                        </MDButton>
                                    </DialogActions>
                                </Dialog>

                                <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={handleCloseSnackbar}>
                                    <MuiAlert onClose={handleCloseSnackbar} severity={snackbar.severity} elevation={6} variant="filled">
                                        {snackbar.msg}
                                    </MuiAlert>
                                </Snackbar>
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
        </DashboardLayout>
    );
}

export default CasoEstadoListar;
